'use client';

import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { useControllableState } from '@radix-ui/react-use-controllable-state';
import { useMemo } from 'react';

import { TooltipContextActions, TooltipContextState } from './context';

export type TooltipProps = TooltipPrimitive.TooltipProps;

export function Tooltip({
    children,
    open: openProp,
    defaultOpen,
    onOpenChange,
    ...props
}: TooltipProps) {
    const [open, setOpen] = useControllableState({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange,
    });

    const state = useMemo(
        () => ({
            open: open || false,
        }),
        [open]
    );

    const actions = useMemo(
        () => ({
            open: () => setOpen(true),
            close: () => setOpen(false),
        }),
        [setOpen]
    );

    return (
        <TooltipPrimitive.Root
            {...props}
            defaultOpen={open}
            open={open}
            onOpenChange={setOpen}
        >
            <TooltipContextState.Provider value={state}>
                <TooltipContextActions.Provider value={actions}>
                    {children}
                </TooltipContextActions.Provider>
            </TooltipContextState.Provider>
        </TooltipPrimitive.Root>
    );
}
